const bgImg = {
  state: {
    /*背景图片
    *  只需要修改require里面的路径（图片存放于assets/img/bgImg文件夹中）
    * */
    bgImg: {
      newListBgImg: require('../../assets/img/bgImg/bgtop-news.jpg'), //新闻资讯背景图片
      productListBgImg: require('../../assets/img/bgImg/bgtop-prod.jpg'), //产品中心背景图片
      caseListBgImg: require('../../assets/img/bgImg/bgtop-anli.jpg'), //经典案例背景图片
      companyListBgImg: require('../../assets/img/bgImg/bgtop-com.jpg'), //公司简介背景图片
      caseDetailBgImg: require('../../assets/img/bgImg/bgtop-anli.jpg'), //经典案例详情页背景图片
      newsDetailBgImg: require('../../assets/img/bgImg/bgtop-anli.jpg'), //新闻资讯详情页背景图片
    }
  }
}

export default bgImg